import ApplicationSpecificConfig from "applications/ApplicationSpecificConfig"
import { applicationSubdomain } from "constants/defaultValues/defaultValues"

export default ApplicationSpecificConfig[applicationSubdomain]
  .accountManagerRoutes

// returns the routes for specific application from application specific configuration
